import { render } from "./FeaturesScreen.vue?vue&type=template&id=75d640f9&scoped=true"
import script from "./FeaturesScreen.vue?vue&type=script&lang=js"
export * from "./FeaturesScreen.vue?vue&type=script&lang=js"

import "./FeaturesScreen.vue?vue&type=style&index=0&id=75d640f9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75d640f9"

export default script